import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormatRepeatingListsValuesResponseDto } from '../api/data-model';
import { BACKEND_URL } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) { }

  formatRepeatingListsValues(jsonData: string): Observable<FormatRepeatingListsValuesResponseDto> {
    return this.http.post<FormatRepeatingListsValuesResponseDto>(`${this.baseUrl}/api/app/gpt/format-repeating-lists-values`, { jsonData });
  }
}
